<template>
  <div class="svg-item" v-show="typeof projectSeasonChartData.percentShow === 'number'">
    <svg width="100%"
         height="100%"
         viewBox="0 0 40 40"
         class="donut"
         :style="`--donut-procent: ${projectSeasonChartData.percentShow}; --donut-procent-left: ${projectSeasonChartData.percentShowLeft};`">
      <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>
      <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"></circle>
      <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"
              :stroke-dasharray="projectSeasonChartData.strokeDasharray" stroke-dashoffset="25">
      </circle>
      <g class="donut-text donut-text-1">
        <text y="50%" transform="translate(0, 2)">
          <tspan x="50%" text-anchor="middle" class="donut-percent">{{ projectSeasonChartData.percent }} %</tspan>
        </text>
        <text y="60%" transform="translate(0, 2)">
          <tspan x="50%" text-anchor="middle" class="donut-data mod-project"> {{ projectSeasonChartData.labels[0] }}: {{ projectSeasonChartData.data[0] }}</tspan>
        </text>
        <text y="67%" transform="translate(0, 2)">
          <tspan x="50%" text-anchor="middle" class="donut-data"> {{ projectSeasonChartData.labels[1] }}: {{ projectSeasonChartData.data[1] }}</tspan>
        </text>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  data () {
    return {
      showDonut: false
    }
  },

  computed: {
    ...mapGetters('budget', ['budgetTotal']),
    ...mapGetters('project', ['currentProjectId']),

    projectSeasonChartData () {
      const budgetTotal = this.budgetTotal(this.currentProjectId)
      const percent = (budgetTotal.projectTotal / budgetTotal.seasonTotal * 100).toFixed(1)
      let percentShow = percent
      if (percent > 99) {
        percentShow = 99
      } else if (percent < 1) {
        percentShow = 1
      }

      return {
        strokeDasharray: `${percentShow} ${100 - percentShow}`,
        percent,
        percentShow,
        percentShowLeft: 100 - percentShow,
        labels: [this.$t('budget.chart.project'), this.$t('budget.chart.season')],
        data: [budgetTotal.projectTotal || 0, budgetTotal.seasonTotal || 0]
      }
    }
  }
}
</script>

<style lang="scss">
.charts {
  display: flex;
  justify-content: space-around;
}

:root {
  --donut-color: #7570b3;
}
.svg-item {
  width: 100%;
  font-size: 15px;
  margin: 0 auto;
  animation: donutfade 1s;
}

@keyframes donutfade {
  0% {
    opacity: .2;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 992px) {
  .svg-item {
    width: 80%;
  }
}

.donut-ring {
  stroke: #EBEBEB;
}

.donut-segment {
  transform-origin: center;
}

.donut-segment-2 {
  stroke: var(--donut-color);
  animation: donut1 3s;
}

.donut-percent {
  animation: donutfadelong 1s;
}

@keyframes donutfadelong {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes donut1 {
  0% {
    stroke-dasharray: 0, 100;
  }
  100% {
    stroke-dasharray: var(--donut-procent), var(--donut-procent-left);
  }
}

.donut-text {
  font-family: Arial, Helvetica, sans-serif;
}
.donut-text-1 {
  fill: var(--donut-color);
}

.donut-label {
  font-size: 0.28em;
  font-weight: 700;
  line-height: 1;
  fill: #000;
  transform: translateY(0.25em);
}

.donut-percent {
  font-size: 0.4em;
  line-height: 1;
  transform: translateY(0.2em);
  font-weight: bold;
}

.donut-data {
  font-size: 0.14em;
  line-height: 1;
  transform: translateY(0.5em);
  text-align: center;
  text-anchor: middle;
  color: #666;
  fill: #666;
  animation: donutfadelong 1s;
}

.donut-data.mod-project {
  font-weight: bold;
  fill: var(--donut-color);
}

.svg-item {
  display: inline-block;
}
</style>
